/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instruction_5Inputs */

const en_login_offline_instruction_5 = /** @type {(inputs: Login_Offline_Instruction_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the Machine ID and click Activate to generate an Activation Code`)
};

const fr_login_offline_instruction_5 = /** @type {(inputs: Login_Offline_Instruction_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez l'ID de Machine et cliquez sur Activer pour générer un Code d'Activation`)
};

const de_login_offline_instruction_5 = /** @type {(inputs: Login_Offline_Instruction_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie die Maschinen-ID ein und klicken Sie auf „Aktivieren“, um einen Aktivierungscode zu generieren.`)
};

const it_login_offline_instruction_5 = /** @type {(inputs: Login_Offline_Instruction_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci l'ID macchina e fai clic su Attiva per generare un codice di attivazione`)
};

const ru_login_offline_instruction_5 = /** @type {(inputs: Login_Offline_Instruction_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите идентификатор устройства и нажмите «Активировать», чтобы сгенерировать код активации.`)
};

const es_login_offline_instruction_5 = /** @type {(inputs: Login_Offline_Instruction_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrese el ID de la máquina y haga clic en Activar para generar un código de activación`)
};

const zh_cn2_login_offline_instruction_5 = /** @type {(inputs: Login_Offline_Instruction_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入机器 ID，然后单击“激活”以生成激活码。`)
};

const ja_login_offline_instruction_5 = /** @type {(inputs: Login_Offline_Instruction_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マシンIDを入力し、「アクティベート」をクリックしてアクティベーションコードを生成します。`)
};

const hi_login_offline_instruction_5 = /** @type {(inputs: Login_Offline_Instruction_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मशीन आईडी दर्ज करें और एक्टिवेशन कोड जनरेट करने के लिए एक्टिवेट पर क्लिक करें।`)
};

const pt_pt2_login_offline_instruction_5 = /** @type {(inputs: Login_Offline_Instruction_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira o ID da máquina e clique em Ativar para gerar um código de ativação.`)
};

/**
* | output |
* | --- |
* | "Enter the Machine ID and click Activate to generate an Activation Code" |
*
* @param {Login_Offline_Instruction_5Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instruction_5 = /** @type {((inputs?: Login_Offline_Instruction_5Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instruction_5Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_instruction_5(inputs)
	if (locale === "de") return de_login_offline_instruction_5(inputs)
	if (locale === "it") return it_login_offline_instruction_5(inputs)
	if (locale === "ru") return ru_login_offline_instruction_5(inputs)
	if (locale === "es") return es_login_offline_instruction_5(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_instruction_5(inputs)
	if (locale === "ja") return ja_login_offline_instruction_5(inputs)
	if (locale === "hi") return hi_login_offline_instruction_5(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_instruction_5(inputs)
	return en_login_offline_instruction_5(inputs)
});